// index.tsx
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import CustomizationsProvider from "@personicom/customizations";
import { ErrorProvider, libraryVersion } from "@personicom/customizations";
import { LicenseInfo } from '@mui/x-license';

// Set MUI X license key before rendering any components
const XGRID_KEY = "c2d51dca3d8ae8b07c58b53ff0ceb2c5Tz0xMDEwNTMsRT0xNzYyMDE3MjA3MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI=";
LicenseInfo.setLicenseKey(XGRID_KEY);

// Log application version info (types defined in vite-env.d.ts)
console.log(`Personicom.NT.UI.Reporting v${__APP_VERSION__} (Build: ${__BUILD_NUMBER__}, Commit: ${__COMMIT_HASH__.substring(0, 7)})`);

const customizationsBuildTime = libraryVersion?.buildTimestamp
  ? new Date(libraryVersion.buildTimestamp).toISOString()
  : "unknown";
console.log(`@personicom/customizations v${libraryVersion?.version || "unknown"} (Build: ${customizationsBuildTime})`);

ReactDOM.render(
  <React.StrictMode>
    <CustomizationsProvider>
      <ErrorProvider>
        <App />
      </ErrorProvider>
    </CustomizationsProvider>,
  </React.StrictMode>,
  document.getElementById("root")
);
